export default "__VITE_ASSET__19f401ff__"